module.exports = __webpack_public_path__ + "img/GEG_120X35.06689e08.png";